mutation DeleteSmsCampaign($input: CampaignDeleteInput!) {
    campaignDelete(input: $input) {
        campaign {
            id
        }
    }
}
